import { render, staticRenderFns } from "./ExpenseEdit.vue?vue&type=template&id=1040a48a&scoped=true"
import script from "./ExpenseEdit.vue?vue&type=script&lang=js"
export * from "./ExpenseEdit.vue?vue&type=script&lang=js"
import style0 from "./ExpenseEdit.vue?vue&type=style&index=0&id=1040a48a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1040a48a",
  null
  
)

export default component.exports